import type { PostgrestError } from '@supabase/supabase-js';

/** True for statement timeout / cancel — keep last loaded data instead of failing the whole CRM refresh. */
export function isTransientLoadError(err: PostgrestError | null): boolean {
  if (!err) return false;
  const msg = err.message ?? '';
  const code = err.code ?? '';
  return (
    code === '57014' ||
    /statement timeout|canceling statement|query canceled|connection.*timed out/i.test(msg)
  );
}

/** True when a table is missing / not in API schema — app can continue without that feature. */
export function isOptionalTableError(err: PostgrestError | null, table: string): boolean {
  if (!err) return true;

  const msg = err.message ?? '';
  const code = err.code ?? '';
  const status = (err as PostgrestError & { status?: number }).status;

  if (code === 'PGRST205' || code === 'PGRST204' || code === '42P01') return true;
  if (status === 404 || code === '404') return true;
  if (/relation|does not exist|schema cache|not found/i.test(msg) && new RegExp(table, 'i').test(msg)) {
    return true;
  }
  if (new RegExp(table, 'i').test(msg)) return true;
  if (/relation|does not exist|schema cache/i.test(msg)) return true;

  return false;
}
